import { ActualParameter } from '../../execute-forms/entities/execute-form.entity';

export class CustomizeAciton {
    id: string;
    code: string;
    name: string;
    terminalType: string;
    // enable: boolean;
    actualParameters: ActualParameter[];
    constructor(id?: string, code?: string, name?: string) {
        this.id = id;
        this.code = code;
        this.name = name;
    }
}
